import { styled } from "@linaria/react";
export const MarkdownContainer = /*#__PURE__*/styled('div')({
  name: "MarkdownContainer",
  class: "gdg-mnuv029",
  propsAsIs: false
});

